import { Box, Dialog, DialogContent } from '@material-ui/core';
import styled from 'styled-components';

export const ValidityFilterBox = styled.section`
  display: flex;
  position: absolute;
  top: 75px;
  left: 18%;
  z-index: 9;
  width: 70%;
  max-height: ${({ filterOpen }) => (filterOpen ? 'auto' : '0px')};
  transition: all 0.9s;
  overflow: ${({ filterOpen }) => (filterOpen ? 'visible' : 'hidden')};

  .validityCard {
    border: solid 1px transparent;
    border-radius: 4px;
    box-shadow: 0px 4px 4px 0px #00000040;
    display: flex;
    flex-direction: column;
    background: transparent;
    padding: 2px 5px;
    margin-right: 10px;
    width: 32%;
    cursor: pointer;

    &:last-of-type {
      margin-right: 0;
    }

    .title,
    span {
      font-size: 12px !important;
    }

    .title {
      color: #010311;
      font-weight: bold;
      border-bottom: solid 1px #010311;
      padding-bottom: 2px;
      margin-bottom: 2px;
    }

    .labelAndValue {
      display: flex;
      justify-content: space-between;

      span {
        color: #454a67;
        margin-right: 10px;
      }
    }

    &.expired,
    &.onDate,
    &.valid {
      box-shadow: 4px 4px 4px 0px #00000080;

      &.active {
        border: solid 1px #000000;
        color: #fff;

        .title {
          color: #fff;
          border-bottom: solid 1px #fff;
        }
      }
    }

    &.expired {
      background: #f7d4d7;

      &.active {
        background: #f53d4c;
      }
    }

    &.onDate {
      background: #fff2cc;

      &.active {
        background: #f2b90d;
      }
    }

    &.valid {
      background: #d2f9d6;

      &.active {
        background: #08aa15;
      }
    }
  }

  @media (max-width: 602px) {
    top: 0;
    left: 0%;
    width: calc(100% + 20px);
    margin-left: -10px;
    position: sticky;
    background: #5062f0;
    padding: ${({ hasSelectedProduct, simplifiedVersion }) =>
      !simplifiedVersion ? '10px' : hasSelectedProduct ? '10px 10px 0 10px' : '0px 10px'};
    border-radius: 2px 2px 0 0;

    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    display: flex;

    .validityCard {
      width: 100%;
      margin-right: 0;
    }
  }

  @media (min-width: 602px) and (max-width: 801px) {
    margin-top: ${({ simplifiedVersion }) => (simplifiedVersion ? '0px' : '-50px')};
    top: ${({ simplifiedVersion }) => (simplifiedVersion ? '0px' : '10px')};
    left: ${({ simplifiedVersion }) => (simplifiedVersion ? '0px' : '21%')};
    width: ${({ simplifiedVersion }) => (simplifiedVersion ? '100%' : '55%')};
    position: ${({ simplifiedVersion }) => (simplifiedVersion ? 'relative' : 'sticky')};
  }

  @media (min-width: 801px) and (max-width: 1024px) {
    top: ${({ simplifiedVersion }) => (simplifiedVersion ? '0px' : '10px')};
    left: ${({ simplifiedVersion }) => (simplifiedVersion ? '0px' : '22%')};
    width: ${({ simplifiedVersion }) => (simplifiedVersion ? '100%' : '58%')};
    position: ${({ simplifiedVersion }) => (simplifiedVersion ? 'relative' : 'sticky')};
  }

  @media (min-width: 1025px) {
    top: ${({ simplifiedVersion }) => (simplifiedVersion ? '0px' : '65px')};
    left: ${({ simplifiedVersion, alignRight }) => (simplifiedVersion ? '0px' : alignRight ? '53%' : '27%')};
    width: ${({ simplifiedVersion }) => (simplifiedVersion ? '100%' : '33%')};
    position: ${({ simplifiedVersion }) => (simplifiedVersion ? 'relative' : 'absolute')};
  }
`;

export const SelectAllBox = styled.section`
  display: flex;
  position: absolute;
  top: 75px;
  z-index: 9;

  /* por padrão vamos ancorar o botão à direita do cabeçalho/filtros */
  right: 5%;
  width: 200px;
  justify-content: flex-end;

  /* quando o filtro estiver recolhido, escondemos a área do botão */
  max-height: ${({ filterOpen }) => (filterOpen ? 'auto' : '0px')};
  transition: all 0.9s;
  overflow: ${({ filterOpen }) => (filterOpen ? 'visible' : 'hidden')};

  /* MOBILE */
  @media (max-width: 602px) {
    position: sticky;
    top: 0;
    right: 0;
    width: 100%;
    margin-left: -10px;
    padding: ${({ simplifiedVersion }) =>
      simplifiedVersion ? '10px' : '0 10px'};
    background: #5062f0;
    border-radius: 2px 2px 0 0;
    justify-content: center;
  }

  /* MEDIUM TABLET */
  @media (min-width: 602px) and (max-width: 801px) {
    position: ${({ simplifiedVersion }) =>
      simplifiedVersion ? 'relative' : 'sticky'};
    top: ${({ simplifiedVersion }) => (simplifiedVersion ? '0px' : '10px')};
    right: ${({ simplifiedVersion }) => (simplifiedVersion ? '0px' : '2%')};
    width: ${({ simplifiedVersion }) => (simplifiedVersion ? '100%' : '180px')};
    justify-content: ${({ simplifiedVersion }) =>
      simplifiedVersion ? 'center' : 'flex-end'};
  }

  /* LARGE TABLET */
  @media (min-width: 801px) and (max-width: 1024px) {
    position: ${({ simplifiedVersion }) =>
      simplifiedVersion ? 'relative' : 'sticky'};
    top: ${({ simplifiedVersion }) => (simplifiedVersion ? '0px' : '10px')};
    right: ${({ simplifiedVersion }) => (simplifiedVersion ? '0px' : '3%')};
    width: ${({ simplifiedVersion }) => (simplifiedVersion ? '100%' : '190px')};
    justify-content: ${({ simplifiedVersion }) =>
      simplifiedVersion ? 'center' : 'flex-end'};
  }

  /* DESKTOP */
  @media (min-width: 1025px) {
    position: ${({ simplifiedVersion }) =>
      simplifiedVersion ? 'relative' : 'absolute'};
    top: ${({ simplifiedVersion }) => (simplifiedVersion ? '0px' : '65px')};
    right: ${({ simplifiedVersion }) => (simplifiedVersion ? '0px' : '6%')};
    width: ${({ simplifiedVersion }) => (simplifiedVersion ? '100%' : '200px')};
    justify-content: ${({ simplifiedVersion }) =>
      simplifiedVersion ? 'center' : 'flex-end'};
  }
`;

export const SelectAllToggleButton = styled.button`
  width: 110px;
  min-height: 40px;
  border: none;
  border-radius: 4px;
  background: #f2f3f8;
  color: ${({ $active }) => ($active ? '#5062F0' : '#9296AC')};
  font-weight: 700;
  padding: 6px 8px;
  cursor: pointer;
  white-space: normal;
  text-align: center;
  line-height: 1.15;
  word-break: normal;
  overflow-wrap: anywhere;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 4px 0px #00000040;


  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ProductTable = styled.table`
  /* SMALL TABLET */
  table-layout: fixed;

  .imageColumn {
    width: 8%;
  }

  .descriptionColumn {
    width: 33%;
  }

  .unitColumn {
    width: 5%;
  }

  .flagsColumn {
    border-left: solid 1px rgba(208, 211, 226, 1);
  }

  .categoryColumn {
    width: 18%;
    border-left: solid 1px rgba(208, 211, 226, 1);
  }

  .stockAndValidityColumn {
    width: 19%;
    background: #4d0073;
    border-left: solid 1px #860891;
  }

  .iconsColumn {
    width: 17%;
    border-left: solid 1px #333541;
  }

  tbody {
    .lineBorder {
      height: 50px;

      .description {
        vertical-align: top;

        td {
          line-height: 1.8;
          padding-top: 3px !important;
        }
      }
    }

    .productStockAndValidityBox {
      display: flex;
      justify-content: flex-end;
      width: 100%;

      .productStockAndValidityValues {
        display: flex;
        flex-direction: column;
        width: calc(100% - 18px);

        .validityValue {
          font-size: 10px;
          line-height: 1.5;
        }
      }

      .validityStatusBar {
        margin: 8px 0 0 8px;
        background: #d0d3e2;
        box-shadow: 0px 4px 4px 0px #00000040;
        border-radius: 2px;
        width: 10px;
        height: 35px;
      }
    }

    .valid {
      .validityValue {
        color: #006608;
      }

      .validityStatusBar {
        background: #d2f9d6;
      }
    }

    .expired {
      .validityValue {
        color: #f53d4c;
      }

      .validityStatusBar {
        background: #f7d4d7;
      }
    }

    .onDate {
      .validityValue {
        color: #aa8208;
      }

      .validityStatusBar {
        background: #fff2cc;
      }
    }

    .iconsColumnValues {
      img {
        width: 34px;
      }
    }
  }

  /* MEDIUM TABLET */
  @media (min-width: 602px) and (max-width: 801px) {
    .imageColumn {
      width: 6%;
    }

    .descriptionColumn {
      width: 43%;
    }

    .unitColumn {
      width: 4%;
    }

    .categoryColumn {
      width: 21%;
    }

    .stockAndValidityColumn {
      width: 14%;
    }

    .iconsColumn {
      width: 12%;
    }
  }

  /* DESKTOP */
  @media (min-width: 801px) {
    .imageColumn {
      width: 4%;
    }

    .descriptionColumn {
      width: 24%;
    }

    .unitColumn {
      width: 2%;
    }

    .flagsColumn {
      width: 4%;
    }

    .categoryColumn {
      width: 17%;
    }

    .conservationColumn {
      width: 19%;
    }

    .validityColumn {
      width: 5%;
    }

    .maturityColumn {
      width: 16%;
      border-left: solid 1px #860891;
      background: #860891 !important;
    }

    .iconsColumn {
      width: 9%;
    }

    tbody {
      .lineBorder {
        height: auto;

        .description {
          vertical-align: middle;

          td {
            line-height: auto;
            padding-top: 0px !important;
          }
        }

        .labelCountContainer {
          display: grid;
          grid-gap: 5px;
          grid-template-columns: repeat(3, 1fr);
          place-items: center;
          padding: 5px;

          .labelCountItem {
            width: 62px;
            height: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: solid 1.5px transparent;
            border-radius: 20px;

            &.hasValue {
              border: solid 1.5px #010311;
            }

            &.expired {
              background: #f7d4d7;
            }

            &.onDate {
              background: #fff2cc;
            }

            &.valid {
              background: #d2f9d6;
            }

            span {
              color: #010311;
              font-weight: bold;
            }
          }
        }
      }

      .productStockAndValidityBox {
        display: flex;
        justify-content: flex-end;
        width: 100%;

        .productStockAndValidityValues {
          flex-direction: row;
          width: 100%;

          .validityValue {
            display: none;
          }
        }

        .validityStatusBar {
          display: none;
        }
      }

      .iconsColumnValues {
        button {
          margin-right: 10px;

          &:last-of-type {
            margin-right: 0;
          }
        }

        img {
          width: 20px;

          &.deleteProductIcon {
            width: 16px;
          }
        }
      }
    }
  }
`;

export const ProductDialogContainer = styled(Dialog)`
  /* TABLET */
  @media (max-width: 801px) {
    width: 100%;

    .MuiDialog-container {
      .MuiPaper-root {
        width: 96%;
        margin: auto;
      }
    }
  }

  .cardDefault {
    padding: 28px 16px 16px;
    margin: 16px;
    background: #daddf3;
    box-shadow: 4px 4px 4px 0px #00000080;

    .MuiGrid-item {
      margin-bottom: 15px;

      label {
        text-transform: uppercase;
        transform: translate(0px, -19px) scale(1) !important;
      }

      input {
        &::placeholder,
        &::-webkit-input-placeholder {
          text-transform: uppercase;
        }
      }
    }

    .MuiInputBase-root {
      height: 40px;
    }

    .selectSmallBox {
      label {
        transform: translate(0px, -4px) scale(1) !important;
      }

      .ant-select-selector {
        height: 40px !important;

        .ant-select-selection-placeholder,
        .ant-select-selection-item {
          display: flex;
          align-items: center;
          text-transform: uppercase;
        }
      }
    }

    .productImageContainer {
      display: flex;

      .croppedImageBox {
        .croppedImage {
          height: 40px;
          width: 40px;
          border-radius: 4px;
          border: solid 1px #9296ac;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            max-width: 100%;
            max-height: 100%;
            object-fit: cover;
            background: rgba(255, 255, 255, 0.4);
          }
        }
      }
    }
  }

  .dialogActions {
    padding: 0 16px 16px;
  }
`;

export const MobileProductsContainer = styled.section`
  margin-bottom: 20px;

  .fakeWhiteBg {
    background: #fff;
    width: calc(100% + 20px);
    margin-left: -10px;
    height: 150px;
    position: fixed;
    top: 0;
    z-index: 1;
  }

  @media (max-width: 602px) {
    .fakeWhiteBg {
      height: 100px;
    }
  }

  @media (min-width: 602px) {
    .fakeWhiteBg {
      height: 150px;
    }
  }
`;

export const PaginationWrapper = styled.div`
  @media (max-width: 1025px) {
    margin-bottom: 140px;
    display: flex;
    flex-direction: column;

    nav {
      button {
        width: 35px;
        height: 35px;
        font-size: 16px;
      }
    }

    .itemsPerPage {
      margin-top: 5px;
      font-size: 16px;
    }
  }
`;

export const ProductFilter = styled.div`
  background: #5062f0;
  box-shadow: 0px 4px 4px 0px #00000080;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px 10px;
  margin: 0 0px 10px -10px;
  width: calc(100% + 20px);
  position: sticky;
  top: 69px;
  z-index: 9;

  .MuiInputBase-root {
    &:before {
      border: none;
    }
  }

  .autocompleteSmall {
    .MuiInputBase-root {
      padding: 9px 30px 5px 0px !important;
    }
  }

  .MuiFormControl-root {
    background: #fff;
    border-radius: 20px;
    padding: 1px 10px 5px;

    input {
      font-size: 16px;
    }
  }

  @media (min-width: 577px) and (max-width: 602px) {
    margin: 0px 0px 17px -10px;
  }

  /* @media (max-width: 602px) {
    position: sticky;
    top: 0;
  } */

  /* TABLET */
  @media (min-width: 602px) {
    top: 70px;
    margin: 0px 0px 27px -10px;
  }
`;

export const ProductListContainer = styled.section`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr;

  .emptyLine {
    grid-column: span 3;
    text-align: center;
  }

  @media (min-width: 577px) and (max-width: 602px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 603px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const ProductCardContainer = styled.div`
  border: solid 2px #454a67;
  border-radius: 24px;
  box-shadow: 0px 4px 4px 0px #00000080;
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  width: 100%;

  p,
  span,
  td {
    font-size: 14px;
    line-height: 1.2;

    td {
      font-size: 14px !important;
      line-height: 1.2;
    }
  }
`;

export const ProductTopInfos = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  .title {
    width: calc(100% - 80px);
  }

  img {
    width: 85px;
    height: 58px;
    object-fit: cover;
    border-radius: 4px;
    overflow: hidden;
  }
`;

export const ProductBottomInfos = styled.div`
  display: flex;
  justify-content: space-between;
  border-top: solid 1px #010311;
  margin-top: 5px;
  padding-top: 5px;

  .conservationInfo {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    min-height: 25px;
    margin: auto 0;
    width: 95px;

    span {
      color: #5062f0;
      font-weight: bold;
      text-transform: uppercase;
      font-size: 12px !important;

      td {
        font-size: 12px !important;
      }

      &.quantityValidDays {
        color: #010311;
        font-size: 10px !important;
        font-weight: normal;
        margin-bottom: 5px;

        td {
          font-size: 10px !important;
        }
      }
    }
  }

  .bottomRightContainer {
    display: flex;
  }

  .labelCountContainer {
    display: grid;
    grid-gap: 5px;
    grid-template-columns: repeat(3, 1fr);
    place-items: center;
    margin-right: 5px;
    background: #7583f0;
    border-radius: 4px;
    padding: 5px;

    .labelCountItem {
      width: 34px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: solid 1.5px transparent;
      border-radius: 4px;

      &.hasValue {
        border: solid 1.5px #010311;
      }

      &.expired {
        background: #f7d4d7;
      }

      &.onDate {
        background: #fff2cc;
      }

      &.valid {
        background: #d2f9d6;
      }

      span {
        color: #010311;
        font-weight: bold;
      }
    }
  }

  img {
    width: 44px;
    height: 44px;
  }

  @media (min-width: 577px) and (max-width: 602px) {
    .conservationInfo {
      width: 75px;
    }
  }

  @media (min-width: 603px) {
    .conservationInfo {
      width: 80px;
    }

    .labelCountContainer {
      grid-gap: 3px;

      .labelCountItem {
        width: 28px;
        height: 23px;
      }
    }

    img {
      width: 35px;
      height: 35px;
    }
  }
`;

export const PrintParametersDialogContainer = styled(Dialog)`
  @media (max-width: 1025px) {
    width: 100%;
  }
`;

export const LabelPrintConfigDialogContainer = styled(Dialog)`
  width: 100%;

  .validityInfosBox {
    margin: -1px 10px;
  }

  .MuiDialog-scrollPaper {
    align-items: flex-start;
    margin-top: 30%;
  }

  .MuiPaper-root {
    border-radius: 8px;
    max-width: 100%;
    width: 100% !important;
    margin: 10px;
  }

  .autocompleteSmall {
    background: #5062f0;
    border-radius: 8px 8px 0 0;
    padding: 8px;

    .MuiFormControl-root {
      background: #fff;
      border-radius: 20px;
      padding: 5px 10px 8px;

      .MuiInputBase-root {
        &:before {
          border: none;
        }
      }
    }
  }

  .dialogContainer {
    background: #5062f0;
    border-radius: 0 0 8px 8px;
    box-shadow: 4px 4px 4px 0px #00000080;
    display: flex;
    flex-direction: column;

    .MuiDialogContent-root {
      background: #fff;
      margin: 8px;
      border-radius: 8px;
      overflow: hidden;
      padding: 8px;
    }

    &.noBorderTop {
      border-radius: 0 0 8px 8px;
    }

    &.newPrintProductConfig {
      border-radius: 0 0 8px 8px;

      .title {
        td {
          color: #9296ac;
          font-style: italic;
        }
      }

      .stockValue {
        color: #9296ac;
        font-style: italic;
      }

      .lineValue {
        color: #9296ac;
        font-style: italic;
      }
    }

    .MuiDialogActions-root {
      p {
        color: #fff;
        margin-bottom: 0;
        font-size: 12px;
        font-weight: bold;
      }

      .MuiFormControl-root {
        background: #fff;
        border-radius: 20px;
        padding: 13px 8px;

        input {
          font-size: 16px !important;
          margin-bottom: 0;
        }

        fieldset {
          border: none;
        }
      }

      .numberOfLabelsField {
        width: 50%;
        border-radius: 8px;
        margin-left: 5px;
      }

      .printButton {
        font-size: 14px;
        padding: 21px 15px;
        border-color: #fff;
        color: #fff;
        border-radius: 8px;
        width: 70%;
        background: transparent;

        span {
          letter-spacing: normal;
        }
      }

      .disabledButton {
        border-color: #9296ac !important;
        color: #9296ac !important;
        background: transparent !important;
        cursor: auto;
      }
    }
  }

  @media (min-width: 577px) and (max-width: 602px) {
    p,
    span,
    input,
    td {
      font-size: 16px !important;
    }

    .dialogContainer {
      .MuiDialogActions-root {
        p {
          width: 15%;
        }

        .MuiFormControl-root {
          width: 32%;

          input {
            font-size: 16px !important;
          }
        }

        .numberOfLabelsField {
          width: 16%;
          margin-left: 8px;
        }

        .printButton {
          padding: 24px 15px;
          width: 37%;
        }
      }
    }
  }

  @media (min-width: 602px) and (max-width: 1025px) {
    width: 80%;

    .validityInfosBox {
      background: #5062f0;
      margin: 0;
      padding: 8px 8px 0 8px;
    }

    p,
    span,
    input,
    td {
      font-size: 20px !important;
    }

    .dialogContainer {
      .MuiDialogActions-root {
        .MuiFormControl-root {
          input {
            font-size: 20px !important;
          }
        }
      }

      .MuiDialogActions-root {
        p {
          width: 15%;
          font-size: 16px !important;
        }

        .MuiFormControl-root {
          width: 32%;
        }

        .numberOfLabelsField {
          width: 15%;
          margin-left: 8px;
        }

        .printButton {
          font-size: 20px;
          padding: 24px 15px;
          width: 37%;
        }
      }
    }
  }

  /* LARGE TABLET */
  @media (min-width: 801px) and (max-width: 1024px) {
    .validityInfosBox {
      background: #5062f0;
      margin: 0;
      padding: 8px 8px 0 8px;
    }
  }

  @media (min-width: 1025px) {
    width: 40%;

    .validityInfosBox {
      background: #5062f0;
      margin: 0;
      padding: 8px 8px 0 8px;
    }

    .MuiDialog-scrollPaper {
      align-items: center;
    }

    p,
    span,
    input,
    td {
      font-size: 14px !important;

      td {
        font-size: 14px !important;
      }
    }

    .dialogContainer {
      .MuiDialogActions-root {
        .MuiFormControl-root {
          input {
            font-size: 14px !important;
          }
        }
      }

      .MuiDialogActions-root {
        p {
          width: 15%;
        }

        .MuiFormControl-root {
          width: 32%;
        }

        .numberOfLabelsField {
          width: 10%;
          margin-left: 8px;
        }

        .printButton {
          font-size: 14px;
          padding: 20px 15px;
          width: 34%;
        }
      }
    }
  }
`;

export const PrintProductTopInfos = styled.div`
  display: flex;

  .productDescriptionAndStockValue {
    display: flex;
    flex-direction: column;
    width: calc(100% - 100px);
    justify-content: space-between;

    .title {
      font-weight: bold;
      max-height: 34px;

      td {
        line-height: 1.2;
        font-size: 14px !important;
      }
    }

    .stockInfos {
      font-size: 14px;
    }
  }

  img {
    object-fit: cover;
    width: 100px;
    height: 72px;
  }

  @media (min-width: 577px) and (max-width: 602px) {
    img {
      width: 180px;
      height: 132px;
    }

    .productDescriptionAndStockValue {
      .title {
        td {
          font-size: 16px !important;
        }
      }

      .stockInfos {
        font-size: 16px;
      }
    }
  }

  @media (min-width: 602px) {
    img {
      width: 250px;
      height: 182px;
    }

    .productDescriptionAndStockValue {
      .title {
        td {
          font-size: 20px !important;
        }
      }

      .stockInfos {
        font-size: 20px;
      }
    }
  }

  @media (min-width: 1025px) {
    img {
      width: 200px;
      height: 132px;
    }

    .productDescriptionAndStockValue {
      .title {
        td {
          font-size: 14px !important;
        }
      }

      .stockInfos {
        font-size: 14px;
      }
    }
  }
`;

export const PrintProductBottomInfos = styled.div`
  display: flex;
  flex-direction: column;
  border-top: solid 1px #010311;
  margin-top: 8px;
  padding-top: 8px;

  .defaultItemLine {
    margin-bottom: 2px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .expired,
  .onDate,
  .valid {
    font-weight: bold;
  }

  .expired {
    color: #f53d4c;
  }

  .onDate {
    color: #aa8208;
  }

  .valid {
    color: #006608;
  }
`;

export const ProductsSelectorContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 30px;
  border-radius: 100px;
  background-color: #fff;
  margin-top: 10px;

  @media (min-width: 1025px) {
    .MuiFormControl-root {
      height: 40px !important;
    }

    input {
      font-size: 12px;
    }
  }
`;

export const StockExtractDialogContainer = styled(Dialog)`
  .MuiDialog-container {
    .MuiPaper-root {
      background: #1f2445;
      max-width: 640px;
    }
  }

  /* TABLET */
  @media (max-width: 801px) {
    width: 100%;

    .MuiDialog-container {
      .MuiPaper-root {
        width: 96%;
        margin: auto;
      }
    }
  }

  .dialogActions {
    padding: 0 16px 16px;
  }

  /* PHONE */
  @media only screen and (min-device-width: 320px) and (max-device-width: 767px) {
    .filterContainer {
      .MuiFormControl-root {
        label {
          transform: translate(0, -4.5px) scale(0.75);
        }
      }
    }
  }
`;

export const StockExtractDialogContent = styled(DialogContent)`
  padding: 10px;
  height: 500px;
  display: flex;
  flex-direction: column;

  .isLabelClearedFilterBox {
    label {
      background: #9296ac;
      color: #ffffff;
      border-radius: 8px;
      padding: 2px 18px 3px;
    }

    &.active {
      label {
        background: #5062f0;
      }
    }
  }

  .paper {
    background: #ffffff;
  }

  .rightInfos {
    width: 100%;
  }

  .groupedLabelInfos {
    display: flex;
    justify-content: space-between;
    width: 100%;

    span {
      width: 30%;
      text-align: right;
    }
  }

  /* PHONE */
  @media only screen and (max-width: 576px) {
    .isLabelClearedFilterBox {
      label {
        padding: 1px 5px 2px;
      }
    }

    .groupedLabelInfos {
      span {
        width: 58%;
        text-align: right;
      }
    }
  }
`;

export const PrintQrCodeScannerDialogContainer = styled(Dialog)`
  width: 100%;
  .MuiPaper-root {
    border-radius: 8px;
    max-width: 100%;
    width: 100% !important;
    margin: 10px;
  }

  .MuiDialogContent-root {
    padding: 8px;
    /* height: 260px;
    display: flex;
    justify-content: center;
    align-items: center; */
  }

  /* #qr-reader {
    width: 100%;
    max-height: 250px;
    border-radius: 4px; */
  /* } */

  /* #qr-reader video {
    height: 250px !important;
    border-radius: 4px;
  } */

  @media (min-width: 602px) {
    width: 80%;
  }
`;

export const LabelPrintWriteOffDialogContainer = styled(Dialog)`
  width: 100%;

  .MuiPaper-root {
    width: 100%;
  }

  @media only screen and (max-width: 576px) {
    .MuiPaper-root {
      width: 229px;
      margin: 0;
    }

    .title {
      font-size: 13px !important;
    }
  }

  @media (min-width: 577px) and (max-width: 602px) {
    width: 80%;
  }

  @media (min-width: 602px) and (max-width: 801px) {
    width: 60%;
  }

  @media (min-width: 801px) and (max-width: 1024px) {
    width: 50%;
  }

  @media (min-width: 1025px) {
    width: 30%;
  }
`;

export const PrintWriteOffDialogContent = styled(DialogContent)`
  padding: 0;
`;

export const PrintWriteOffTopInfos = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-bottom: solid 1px #d0d3e2;
  padding-top: 10px;
  margin: 15px 0;

  span {
    color: #5062f0;
    font-size: 14px;

    &.title {
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 5px;
    }
  }
`;

export const PrintWriteOffBottomInfos = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  margin-top: 10px;

  span {
    color: #0b0d1d;
    text-align: center;
    font-weight: bold;
    font-size: 14px;
  }
`;

export const WriteOffNumberOfLabelsContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;

  span {
    color: #454a67;
    font-size: 16px;
  }

  .MuiFormControl-root {
    border: solid 1px #010311;
    border-radius: 8px;
    padding: 12px 8px;
    width: 23%;

    input {
      margin-bottom: 3px;
    }

    fieldset {
      border: none;
    }
  }
`;

export const LabelDetailsDialogContainer = styled(Dialog)`
  .MuiDialog-container {
    .MuiPaper-root {
      border: 8px solid #5062f0;
      border-radius: 12px;
      width: 480px;
    }
  }

  .MuiDialogContent-root {
    padding: 8px;
    background: #fff;
    border-radius: 10px;
  }

  @media (max-width: 801px) {
    width: 100%;
    .MuiDialog-container {
      .MuiPaper-root {
        width: 96%;
        margin: auto;
      }
    }
  }
`;

export const LabelsCardDetails = styled.div`
    border: 2px solid ${(props) => (props.$selected ? '#9d9fb0' : '#010311')};
  border-radius: 24px;
  padding: 5px 20px;
  background: ${(props) => (props.$selected ? '#FFF2CC' : '#FFFFFF')};
  height: 130px;
  box-shadow: 2px 4px 4px 0px #00000080;

  .productDescriptionAndStockValue {
    display: flex;
    flex-direction: column;
    width: calc(100% - 100px);
    justify-content: space-between;

    .title {
      font-weight: bold;
      max-height: 34px;

      td {
        line-height: 1.2;
        font-size: 14px !important;
      }
    }

    .stockInfos {
      font-size: 14px;
    }
  }
`;

export const LabelProductBottomInfos = styled.div`
  display: flex;
  flex-direction: column;

  border-top: solid 1px #010311;
  margin-top: 4px;

  .defaultItemLine {
    margin-bottom: 2px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .lineValue {
    font-size: 12px;
  }

  .expired,
  .onDate,
  .valid {
    font-weight: bold;
  }

  .expired {
    color: #f53d4c;
  }
  .onDate {
    color: #aa8208;
  }
  .valid {
    color: #006608;
  }

  .bottomWrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .bottomTexts {
    display: flex;
    flex-direction: column;
    min-width: 0; /* ajuda a evitar quebra com textos longos */
  }

  .clearIconButton {
    border-radius: 8px;
    height: 35px;
    width: 35px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
  }

  .clearIconImg {
    display: block;
    padding-right: 10px;
  }
`;

export const LabelProductTopInfos = styled.div`
  display: flex;
  justify-content: space-between;

  .labelProductDescription {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .title {
    font-size: 16px !important;
  }

  .lineValue {
    font-size: 12px;
  }

  img {
    width: 85px;
    height: 58px;
  }
`;
